import { reactive } from 'vue';
import jwtDecode from 'jwt-decode';
export const state = reactive({
    isAuthenticated: false,
    hasFailed: false,
    isPending: false,
    token: '',
    decodedToken: {},
    username: '',
    roles: [],
    resourceRoles: {},
});
export const setToken = (token) => {
    state.token = token;
    const content = jwtDecode(state.token);
    state.decodedToken = content;
    state.roles = content.realm_access.roles;
    state.username = content.preferred_username;
    state.resourceRoles = content.resource_access
        ? Object.fromEntries(Object.entries(content.resource_access).map(([key, value]) => [key, value.roles]))
        : {};
};
export const hasFailed = (value) => {
    state.hasFailed = value;
};
export const isPending = (value) => {
    state.isPending = value;
};
export const isAuthenticated = (value) => {
    state.isAuthenticated = value;
};
//# sourceMappingURL=state.js.map